
import QueryString, { ParsedQs } from "qs";
import { ProcessInstanceStateFilter } from "../model/ProcessInstanceStateFilter";
import { IFilterType } from "./AppPath";
import { ProcessWithStatus } from "./ProcessWithStatus";
import { getRowsPerPage } from "./RowsPerPage";
import { getVisibleColumnsFromStore } from "./VisibleColumnsStore";

export const defaultCountsTimeLimitDays = 7;

export class ListState {
    public selectedProcessIds: number[];
    public instancesPageProcessGuids: IFilterType;
    public visibleColumns: Array<keyof (ProcessWithStatus)>;
    public currentPage: number | null;
    public sortBy: keyof ProcessWithStatus | null;
    public sortDescending: boolean | null | string;
    public highlightProcess: number | null;
    public filterText: IFilterType;
    public filterCategory: FilterCategory | string | null;
    public tagModalOpenForProcesses: number[] | null;
    public rowsPerPage: number;
    public isSubprocessList: boolean;
    public instanceListStateFilter: ProcessInstanceStateFilter | null;
    public startTime: IFilterType;
    public endTime: IFilterType;
    public countsTimeLimitDays: number;
    public changeLogOpenForProcess: number | null;
    constructor(isSubprocessList?: boolean) {
        this.selectedProcessIds = [];
        this.isSubprocessList = isSubprocessList || false;
        this.instancesPageProcessGuids = null;
        this.visibleColumns = getVisibleColumnsFromStore(this.isSubprocessList);
        this.currentPage = null;
        this.sortBy = "name";
        this.sortDescending = false;
        this.highlightProcess = null;
        this.filterText = null;
        this.filterCategory = null;
        this.rowsPerPage = getRowsPerPage();
        this.startTime = null;
        this.endTime = null;
        this.instanceListStateFilter = null;
        this.countsTimeLimitDays = defaultCountsTimeLimitDays;
    }
}

export const optionalProcessListColumns: Array<{ column: keyof (ProcessWithStatus), label: string }> = [
    { column: "id", label: FRENDS.Localizations.Id },
    { column: "uniqueIdentifier", label: "GUID" },
    { column: "targetFramework", label: "Target framework" },
    { column: "latestExecutionState", label: FRENDS.Localizations.LatestExecutionState },
    { column: "erroredNotAcknowledged", label: FRENDS.Localizations.ProcessInstanceFilter_ShowFailedNotAcknowledged },
    { column: "latestExecutionStartTime", label: FRENDS.Localizations.LatestExecutionStartTime },
    { column: "frendsVersion", label: "Frends version" },
    { column: "tags", label: FRENDS.Localizations.TagString },
    { column: "promotedResultVariables", label: FRENDS.Localizations.PromotedColumn },
    { column: "usedProcessesList", label: FRENDS.Localizations.Subprocesses },
    { column: "executionsPerDay", label: FRENDS.Localizations.LatestInstancesPerDay },
    { column: "running", label: FRENDS.Localizations.ProcessInstanceFilter_ShowRunning },
    { column: "successful", label: FRENDS.Localizations.ProcessInstanceFilter_ShowSuccessful },
    { column: "failed", label: FRENDS.Localizations.ProcessInstanceFilter_ShowFailed },
    { column: "triggers", label: FRENDS.Localizations.ActiveTriggers },
    { column: "modified", label: FRENDS.Localizations.Modified },
    { column: "modifier", label: FRENDS.Localizations.Modifier }
];

export const optionalSubprocessListColumns: Array<{ column: keyof (ProcessWithStatus), label: string }> = [
    { column: "usedByProcessesList", label: FRENDS.Localizations.UsedByProcesses }
];

export enum FilterCategory {
    Text = "Text",
    Tags = "Tags",
    Tasks = "Tasks",
    Triggers = "Triggers",
    ErrorsSince = "ErrorsSince",
    ExecutionsSince = "ExecutionsSince",
    PromotedResultVariables = "PromotedResultVariables",
    UsedBy = "UsedBy",
    Subprocesses = "Subprocesses"
}
